export default __webpack_public_path__ + "static/media/a017-10.e757b7e0.svg";